module.exports = __webpack_public_path__ + "static/3-c9de67df790900a29bccccfe2113b4c1.jpeg";